module.exports = __webpack_public_path__ + "img/HY2702-01.0249dd59.jpg";